Object.defineProperty(exports, "__esModule", { value: true });
var Role;
(function (Role) {
	Role["ADMIN"] = "admin";
	Role["USER"] = "user";
})(Role || (Role = {}));
exports.default = Role;
